module.exports = __webpack_public_path__ + "static/media/weedmaps-logo-grey.b41c0ed1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weedmaps-logo-grey.svg
// module id = 2439
// module chunks = 0